import { render, staticRenderFns } from "./adminMessage.vue?vue&type=template&id=edf54f2c&"
import script from "./adminMessage.vue?vue&type=script&lang=js&"
export * from "./adminMessage.vue?vue&type=script&lang=js&"
import style0 from "./adminMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports